import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './HeaderGenericTertiary.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
// import { useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM } from '../../utils';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
// import { ltrStyles, rtlStyles } from '../57_HeaderGenericPrimary/HeaderGenericPrimary';
// import { qsToObject } from '../../utils/querystring';

var HeaderGenericTertiary = function HeaderGenericTertiary(_ref) {
  var fields = _ref.fields;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var pageName = get(fields, 'data.item.headerTag.jss');
  var dotSite = get(sitecoreContext, 'site.name');
  if (dotSite === 'dotsite') {
    pageName = get(fields, 'data.item.pageName');
  }
  var pageTitle = get(fields, 'data.item.pageTitle') || get(fields, 'pageTitle');
  var pageTitleValue = get(fields, 'pageTitle.value') || get(fields, 'data.item.pageTitle.value');
  var pageIntro = get(fields, 'pageIntro') || get(fields, 'data.item.pageIntro');
  // const headerTag = get(fields, 'pageIntro')
  // const location = useLocation();
  // const queryParams = qsToObject(location.search);
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setstate = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM) {
      var hash = window.location.hash;
      var hashvalue = hash.split('#tag=');
      if (hashvalue[1]) setstate("#".concat(decodeURI(hashvalue[1])));
      if (dotSite === 'dotsite') {
        // 50059
        // if (queryParams && queryParams.tags) setstate(` #${decodeURI(queryParams.tags)}`);
      }
    }
  }, []);
  if (!fields) {
    console.warn('HeaderGenericTertiary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericTertiary component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageEditing && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: pageTitle,
    className: "h2 c-title__text"
  }), !pageEditing && /*#__PURE__*/React.createElement("h1", {
    className: "h2 c-title__text"
  }, "".concat(pageTitleValue, " ").concat(state)))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageIntro && /*#__PURE__*/React.createElement(Text, {
    className: "p header__content",
    tag: "p",
    field: pageIntro
  })))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className, " ").concat(headerImageStyle)
  }, children);
};
export var commonStyles = "c1put96c";
export var ltrStyles = "lps6bsb";
export var rtlStyles = "re1b3ee";
export default HeaderGenericTertiary;